module.exports = __webpack_public_path__ + "img/brand_logo_mini.a2258276.svg";